import styled, { css } from 'styled-components';
import LinkButton from './LinkButton';

type Props = { $stepVisited?: boolean };

const WizardLinkButton = styled(LinkButton)<Props>`
  &.MuiButton-textPrimary:hover {
    background-color: transparent;
  }
  &.MuiButton-root:hover {
    background-color: transparent;
  }
  ${({ theme, $stepVisited }) =>
    $stepVisited &&
    css`
      color: ${theme.palette.grey[700]};
    `};
`;

export default WizardLinkButton;
